export default "__VITE_PUBLIC_ASSET__0e5eaf9c__"